import * as React from 'react';
import {
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControlLabel,
	Link,
	Typography,
} from '@mui/material';
import { styled } from '@mui/system';

interface TermsAndConditionModalProps {
	open: boolean;
	onClose: () => void;
	onAccept: () => void;
}

const SecondaryButton = styled(Button)(({ theme }) => ({
	backgroundColor: theme.palette.primary.main,
	//width: '100%',
	whiteSpace: 'nowrap',
	color: '#fff',
	padding: '12px 10px',
	fontFamily: 'AmigaForever',
	fontWeight: 600,
	fontSize: '14px',
	letterSpacing: '0.15em',
	textTransform: 'uppercase',
	boxShadow: 'none',
	clipPath:
		'polygon(15px 0, 100% 0, 100% calc(100% - 15px), calc(100% - 15px) 100%, 0 100%, 0 15px)',
	'&:hover': {
		backgroundColor: theme.palette.primary.dark,
		boxShadow: 'none',
	},
}));

export default function TermsAndConditionModal({
	open,
	onClose,
	onAccept,
}: TermsAndConditionModalProps) {
	const [checked, setChecked] = React.useState(false);

	const handleClose = () => {
		setChecked(false);
		onClose();
	};

	const handleAccept = () => {
		onAccept();
		setChecked(false);
	};

	return (
		<Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
			<DialogTitle
				sx={{
					fontFamily: 'Oxanium, sans-serif',
					fontSize: '25px',
					lineHeight: 1.2,
				}}
			>
				Terms and Condition
			</DialogTitle>
			<DialogContent>
				<FormControlLabel
					control={
						<Checkbox
							checked={checked}
							onChange={(event) =>
								setChecked(event.target.checked)
							}
						/>
					}
					label={
						<span>
							I agree to the{' '}
							<Link
								href="/terms-and-condition"
								target="_blank"
								rel="noreferrer"
								underline="none"
								sx={{ fontWeight: 'bold' }}
							>
								Terms and Conditions
							</Link>
						</span>
					}
				/>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={handleClose}
					sx={{
						fontFamily: 'Oxanium, sans-serif',
					}}
				>
					Cancel
				</Button>
				<SecondaryButton onClick={handleAccept} disabled={!checked}>
					<Typography
						variant="caption"
						fontWeight="bold"
						color="inherit"
					>
						Accept
					</Typography>
				</SecondaryButton>
			</DialogActions>
		</Dialog>
	);
}
